import template from './cardSimulationMoreInfo.html';
import controller from './cardSimulationMoreInfo.controller';
import './cardSimulationMoreInfo.scss';

let cardSimulationMoreInfoComponent = {
  restrict: 'E',
  transclude: true,
  bindings: {
    loanId: '<',
    title: '@',
    iconInfoIsVisible: '<',
    subtitle: '@',
    insurance: '<',
    isMobileApp: '<',
  },
  template,
  controller
};

export default cardSimulationMoreInfoComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/needALoan/requestCardSimulationFamily/cardSimulationMoreInfo/cardSimulationMoreInfo.component.js